import { Tile } from '@op/opds.opux';
import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { color } from '@op/opds.tokens';
import styles from './TaxationTile.module.scss';
import { getMsgValues } from '../../utils';

const useGetMessage = (baseKey: string, suffix: string): string => {
  return useMessage(`${baseKey}.${suffix}`);
};

interface TaxationTileProps {
  baseKey: string;
  costArray: string[];
  showAlternativeCalculation: boolean;
}

const TaxationTile = ({
  baseKey,
  costArray,
  showAlternativeCalculation,
}: TaxationTileProps): ReactElement => {
  const labelArray = getMsgValues(useMessage(`${baseKey}.labels`));
  return (
    <Tile className={styles['tile-container']}>
      <div className={styles['tile-content']}>
        <h4 className="investoracademy-general-graph-title">
          {useGetMessage(baseKey, 'title')}
        </h4>
        <p className="investoracademy-text-paragraph">
          {useGetMessage(baseKey, 'intro')}
        </p>
        <div className="investoracademy-divider-line" />
        <div className={styles['text-content']} style={{ paddingLeft: '0px' }}>
          <p className={styles['label-text']}>{labelArray[0]}</p>
          <p className={styles['body-text']}>{costArray[0]}</p>
        </div>
        <div className="investoracademy-divider-line" />
        {labelArray.slice(1).map((label, index, array) => (
          <div
            key={label}
            className={styles['text-content']}
            style={
              index === array.length - 1 ? { color: color.indicator.negative } : undefined
            }
          >
            <p className={styles['label-text']}>{label}</p>
            <p className={styles['body-text']}>{costArray[index + 1]}</p>
          </div>
        ))}
        <div className="investoracademy-divider-line" />
        <div className={styles['result-content']}>
          <span className="opds-styles-v1-text-body-medium">
            {useGetMessage(baseKey, 'body1')}
          </span>
          <div
            className={`${styles['calculation-container']} opds-styles-v1-text-title-small-strong`}
          >
            <div className={styles['calculation-content']}>
              {useGetMessage(baseKey, 'calc1')}
            </div>
            {showAlternativeCalculation && (
              <>
                <Message id={`${baseKey}.body3`} />
                <div className={styles['calculation-content']}>
                  <Message id={`${baseKey}.calc2`} />
                </div>
              </>
            )}
          </div>
          <span className="opds-styles-v1-text-body-medium">
            {useGetMessage(baseKey, 'body2')}
          </span>
        </div>
      </div>
    </Tile>
  );
};

export default TaxationTile;
